import type { ModeCounts } from '../../view-models';

interface ModeDistributionBarProps {
  modes: ModeCounts;
  height?: number;
  showLabels?: boolean;
}

export function ModeDistributionBar({
  modes,
  height = 6,
  showLabels = false,
}: ModeDistributionBarProps): JSX.Element {
  const total = (modes.h_a || 0) + (modes.h_b || 0) + (modes.h_c || 0);
  if (!total) return <div className="mode-bar mode-bar--empty">sem conversas</div>;
  const pct = {
    h_a: ((modes.h_a || 0) / total) * 100,
    h_b: ((modes.h_b || 0) / total) * 100,
    h_c: ((modes.h_c || 0) / total) * 100,
  };
  return (
    <div className="mode-bar-wrap">
      {showLabels && (
        <div className="mode-bar-labels">
          {modes.h_a > 0 && (
            <span className="mode-bar-label mode-bar-label--ha">H_a {modes.h_a}</span>
          )}
          {modes.h_b > 0 && (
            <span className="mode-bar-label mode-bar-label--hb">H_b {modes.h_b}</span>
          )}
          {modes.h_c > 0 && (
            <span className="mode-bar-label mode-bar-label--hc">H_c {modes.h_c}</span>
          )}
        </div>
      )}
      <div className="mode-bar" style={{ height }}>
        {modes.h_a > 0 && (
          <span
            className="mode-bar__seg mode-bar__seg--ha"
            style={{ width: pct.h_a + '%' }}
            title={`H_a ${modes.h_a}`}
          />
        )}
        {modes.h_b > 0 && (
          <span
            className="mode-bar__seg mode-bar__seg--hb"
            style={{ width: pct.h_b + '%' }}
            title={`H_b ${modes.h_b}`}
          />
        )}
        {modes.h_c > 0 && (
          <span
            className="mode-bar__seg mode-bar__seg--hc"
            style={{ width: pct.h_c + '%' }}
            title={`H_c ${modes.h_c}`}
          />
        )}
      </div>
    </div>
  );
}
